/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-black': {
    width: 19,
    height: 20,
    viewBox: '0 0 19 20',
    data: '<g stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round"><path pid="0" d="M9.49 10v8.47" _stroke="#234357"/><path pid="1" d="M9.49 1.53V10" _stroke="#008AFF"/><path pid="2" d="M17.961 10H1.021" _stroke="#234357"/></g>'
  }
})
